export default {"src":"/_next/static/media/v6.233a0d9e.svg","height":130,"width":332};